import { Machine } from '../../../utils/models/Machine'
import './MachineCardDetail.scss'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../utils/redux/userSlice'
import { Spinner } from 'react-bootstrap'
import { isConnected } from 'aw-date-functions'
import { MachineConected } from 'aw-consts'
import LastStatusInfo from '../../LastStatusComponent/LastStatusInfo/LastStatusInfo.component'
import ModalSinoptic from '../../ModalSinoptic/ModalSinoptic.component'
import { useTheme } from '../../../utils/contexts/ThemeContext'

const MachineCardDetail = (
    props: { 
        machine: Machine, 
        refresh: boolean 
    }) => {

    const user = useSelector(selectUser)
    const { t } = useTranslation()
    const [showModal, setShowModal] = useState<boolean>(false)
    const [customImageFailed, setCustomImageFailed] = useState<boolean>(false)
    const {theme, getCustomThemeImage} = useTheme()
    const publicUrl = process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '.' ? process.env.PUBLIC_URL : ''
    const baseMachineImg = `${publicUrl}/machine-base.png`

    const customMachineImage = getCustomThemeImage("machine")
    const hasValidCustomImageSrc = /^(data:|blob:|https?:\/\/|\/\/|\/)/i.test(customMachineImage?.trim() || '')
    const machineImageSrc = theme === 'custom' && hasValidCustomImageSrc && !customImageFailed ? customMachineImage : baseMachineImg

    useEffect(() => {
        setCustomImageFailed(false)
    }, [customMachineImage, theme])

    const isMachineConected = () => {
        if (props.machine && new Date(props.machine.last_conection).getTime() === new Date(props.machine.createdAt).getTime()) {
            return MachineConected.NoInicilized
        } else if (props.machine && isConnected(new Date(props.machine.last_conection), 70)) {
            return MachineConected.Conected
        }
        return MachineConected.Disconected
    }
    
    return (
        <>
            < ModalSinoptic onHide={() => setShowModal(false)} showModal={showModal} name={props.machine.name}/>
            <div className='kpiContainer2 px-2 rounded-1 d-flex flex-column h-100 position-relative'>
                <span className="mt-1 mb-3 h4 text-center">{props.machine.name}</span>
                <button className="btn-Custom btn-IDGreen bi bi-activity button-container" onClick={() => setShowModal(true)} />

                <LastStatusInfo _id={props.machine.idmachine} token={user.token} refresh={props.refresh} isMachineConnected={isMachineConected()} />
                {props.refresh ? <div className="text-center pt-4"><Spinner animation="border" style={{ color: 'var(--accent-color)' }}/></div> : (
                
                        <div className='last-space my-2 h-100'>
                            <img
                                src={machineImageSrc}
                                className="w-100"
                                style={{objectFit: 'contain'}}
                                onError={(e) => {
                                    e.currentTarget.onerror = null
                                    setCustomImageFailed(true)
                                    e.currentTarget.src = baseMachineImg
                                }}
                            />
                        </div>
                )  
                }
            </div>
        </>
    )
}

export default MachineCardDetail